import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MovieObject } from 'src/app/_interfaces/cinema/MovieObject';
import { environment } from 'src/environments/environment';
import moment from 'moment';

const API_URL = environment.prismaApiUrl +'/api/kino/movies';

@Injectable({
  providedIn: 'root'
})
export class MovieService {
  currentObject: any;
  refreshed: any;
  isNew: Boolean = false;

  constructor(private http: HttpClient) { }
  
  searchMovie(query): Observable<any> {
    return this.http.get('https://api.themoviedb.org/3/search/movie?api_key=4b7dc1e0fdf2ba7f713734a225661dfd&language=de-DE&page=1&include_adult=true&query=' + query);
  }

  getAll(): Observable<any> {
    return this.http.get(API_URL);
  }

  getType(archive:any): Observable<any> {
    return this.http.get(API_URL + '/get-all-by-type/' + archive);
  }

  store(object: any): Observable<any> {
    return this.http.post<MovieObject>(API_URL, {data: object});
  }

  delete(object: any): Observable<any> {
    return this.http.delete(API_URL + '/' + object.id);
  }

  show(id: any): Observable<any> {
    this.currentObject = this.http.get(API_URL + '/' + id);
    if(this.currentObject == null) {this.isNew = true};
    return this.currentObject;
  }

  archiveMovie(id: any): Observable<any> {
    return this.http.get(API_URL + '/archive/' + id);
  }

  update(object: any): Observable<any> {
    return this.http.put<MovieObject>(API_URL + '/' + object.id, {data: object});
  }

  webShowById(id: any): Observable<any> {
    this.currentObject = this.http.get(API_URL + '/web-show-by-id/' + id);
    //console.log(this.currentObject);
    return this.currentObject;
  }

  genPDF(): Observable<any> {
    return this.http.get(API_URL + '/gen-pdf', {responseType: 'arraybuffer'});
  }

  getMovieByDate(date: any): Observable<any> {
    let unixDate = moment(date).unix();
    console.log(unixDate);
    let movies = this.http.get(API_URL + '/get-movie-by-date/' + unixDate);
    return movies;
  }
  

  getCurrentObject() {
    return this.currentObject;
  }

  setRefreshStatus(value: any) {
    this.refreshed = value;
  }

  getRefreshStatus() {
    return this.refreshed;
  }

  setIsNew(value: any) {
    this.isNew = value;
  }

  getIsNew() {
    return this.isNew;
  }

}
